<template>
    <loading
        v-model:active="mostrarLoader"
        color="#001f54"
        loader="dots"
    />

    <section id="tour_details_main" class="section_padding">
       <div class="container">
           <div class="row">
               <div class="col-lg-12">
                   <div class="terms_service_content">
                       <div class="terms_item" v-if="terminosCondiciones">
                            <div v-html="terminosCondiciones.texto"></div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
   </section>

</template>

<script>
import axios from '@/axios'
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/css/index.css';

export default {
   name: "PrivacyPolicyContent",
    components: {Loading},
    props: {
        tipo: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            terminosCondiciones: null,
            mostrarLoader: false
        }
    },
    methods:{
        getTerminosCondiciones () {
            this.openLoadingInDiv()
            axios
                .post("api", {
                    query: `query getTerminosCondiciones($tipo: String!){
                      getTerminosCondiciones(tipo:$tipo){
                          terminosCondiciones{
                              texto
                          }
                          status
                          message
                      }
                  }`,
                variables: {
                    tipo: this.tipo,
                },
                })
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.data.getTerminosCondiciones.status === 'success') {
                            this.terminosCondiciones = response.data.data.getTerminosCondiciones.terminosCondiciones
                        }
                    }
                    this.closeLoadingInDiv()
                })
        },
        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },
    },
    mounted() {
        this.getTerminosCondiciones()
    }
};
</script>